export default function ensureMapLoaded() {
  const start = Date.now()
  return new Promise(waitForMap)

  function waitForMap(resolve, reject) {
    if(window?.mapLoaded) {
      resolve()
    } else if((Date.now() - start) >= 10000) {
      reject(new Error('Map Load Timeout'))
    } else {
      setTimeout(waitForMap.bind(this, resolve, reject), 200)
    }
  }
}
